<template>
  <div>
    <v-select
      v-model="model"
      :options="options"
      label="text"
      :placeholder="placeholder"
    >
      <!-- Slot para cada opción del dropdown -->
      <template #option="{ text, description }">
        <div class="custom-dropdown-option__container">
          <span>{{ text }}</span><br />
          <small class="text-muted">{{ description }}</small>
        </div>
      </template>

      <!-- Slot para cómo se muestra la opción seleccionada -->
      <template #selected-option="{ text, description }">
        <div>{{ text }} - <small class="text-muted">{{ description }}</small></div>
      </template>
    </v-select>
    <Error v-if="hasError" variant="no-border" :message="errorMsg" />
  </div>
</template>

<script>
import vSelect from "vue-select";
import Error from "custom-error";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
    Error
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => ([])
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: 'Campo requerido.'
    },
  },
  data() {
    return {
      model: null,
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.model)) {
          this.model = { ...newValue };
        }
      }
    },
    model: {
      deep: true,
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
          this.$emit('input', newValue);
        }
      }
    }
  }
};
</script>

<style>
.v-select .vs__dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
}

.v-select .vs__dropdown-menu li:hover,
.v-select .vs__dropdown-menu .vs__dropdown-option--highlight {
  background-color: #f5f6f5; /* o el color exacto que uses */
  color: black;
}

.custom-dropdown-option__container {
  padding: 5px 0;
}
</style>